import { useRef, useMemo } from 'react';
import uniqueId from 'lodash/uniqueId';
import gettext from '@sdk/lang/gettext';
import CloseIcon from '@sdk/components/ui/CloseIcon';

import SearchSvg from '@web/assets/svg/Icons/16/search.svg';

import {
  Wrapper,
  SearchInput,
  SearchImageWrapper,
  CloseImageWrapper,
  FloatingLabel,
} from './foldableSearch.styles';
import { useFoldableSearch } from './foldableSearch.hooks';
import { Props } from './foldableSearch.types';

export const FoldableSearch = ({
  submitEager = false,
  transparentBackground = false,
  initialValue,
  onSubmitSearch,
  onCancelSearch,
  onValueChange,
  floatingLabel,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>();
  const inputId = useMemo(() => uniqueId('search'), []);

  const {
    isFocused,
    onIconMouseDown,
    onSubmit,
    onChange,
    onCancel,
    setIsFocused,
    value,
    isCancelVisible,
  } = useFoldableSearch({
    onSubmitSearch,
    onCancelSearch,
    onValueChange,
    submitEager,
    initialValue,
  });

  return (
    <Wrapper transparentBackground={transparentBackground}>
      <form onSubmit={onSubmit}>
        <SearchInput
          id={inputId}
          onChange={onChange}
          onFocusChange={setIsFocused}
          placeholder={gettext('Search')}
          ref={inputRef}
          value={value}
          hasRightIcon={isCancelVisible}
        />
        <SearchImageWrapper
          htmlFor={inputId}
          isActive={Boolean(isFocused || value)}
          onMouseDown={onIconMouseDown}>
          <SearchSvg />
        </SearchImageWrapper>

        {isCancelVisible && (
          <CloseImageWrapper htmlFor={inputId} onMouseDown={onCancel}>
            <CloseIcon />
          </CloseImageWrapper>
        )}
      </form>

      {!!floatingLabel && isFocused && !!value && <FloatingLabel>{floatingLabel}</FloatingLabel>}
    </Wrapper>
  );
};
